import { render, staticRenderFns } from "./NoticeManagementUpdate.vue?vue&type=template&id=6983a488&"
import script from "./NoticeManagementUpdate.vue?vue&type=script&lang=js&"
export * from "./NoticeManagementUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports